import React, { Component } from 'react'
import { Row, Col, Icon } from 'antd';

class Pressrelease extends Component {
    render() {

      const {t} = this.props;

        return (
          <Row>
            <Col span={24}>

              <div style={{minHeight: '300px'}} className="main-press-release" />
              <div style={{position: "absolute", top: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                <h1 style={{ color: '#4D77F8', fontSize: '40px', fontWeight: 900, textAlign: 'center' }}>QUOTES</h1>
                <div style={{ color: '#FFFFFF', fontSize: '22px', fontWeight: 900, textAlign: "center" }}>”What sounds idealistic today becomes realistic tomorrow."</div>
                <div style={{ color: '#FFFFFF', fontSize: '22px', fontWeight: 900 }}>Halfdan Mahler</div>
              </div>
            </Col>
          </Row>
        )
    }
}

export default Pressrelease
